import { useQuery } from "@tanstack/react-query"

import { trpcOptions } from "@/utils/trpc"

export const getPhotosOptions = (sessionId: string) => trpcOptions.sessions.getPhotos.queryOptions({ sessionId })

export function useGetPhotosOptions(sessionId: string) {
  return useQuery(getPhotosOptions(sessionId))
}
